import React from 'react';
import Lottie from 'react-lottie';
import lottieAnimationData from './foodo-loading.json';

const LoadingAnimation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lottieAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div
      style={{
        backgroundColor: '#f5f7fa',
      }}
    >
      <Lottie options={defaultOptions} height={200} width={200} />
    </div>
  );
};

export default LoadingAnimation;
